import { apiRequest } from './_apiRequests';

export function fetchKernelspecs(jupyterUser) {
  const url = `/jupyter/user/${jupyterUser}/api/kernelspecs`;
  return apiRequest(url);
}
